// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loaderProgress.progress-linear{margin:0}.cardLoadText{font-weight:500}.loaderError .expansion-panel__header{text-align:center}.loaderError .errorMsg{padding-left:15px}", ""]);
// Exports
module.exports = exports;
